
import React, { useEffect } from 'react'
import AddHeader from '../components/AddHeader/AddHeader'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FilterContainer from '../components/FilterContainer/FilterContainer';
import CustomTable from '../components/CustomTable/CustomTable';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { fetchCategories } from '../hooks/categories';

function Categories() {
    const navigate = useNavigate();
    const dispatch=useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
        const {list:categories } = useSelector((state) => state.categories);
        
    useEffect(() => {
          dispatch(fetchCategories());
    
    }, [dispatch])
  
  const header = [
    { id: "id", numeric: false, disablePadding: true, label: currentLocal.home.ID },
        { id: "image", numeric: true, disablePadding: false, label: currentLocal.home.image },

    { id: "name_en", numeric: true, disablePadding: false, label:  currentLocal.home.namePlaceholder+" "+currentLocal.home.inEN },
    { id: "name_ar", numeric: true, disablePadding: false, label: currentLocal.home.namePlaceholder+" "+currentLocal.home.inAR},
    { id: "actions", numeric: true, disablePadding: false, label: currentLocal.home.actions },

  ];
  
const myData = categories?.map((item) => {
  return {
    id: item?.id,
        image:<>
        <div className='w-25'>
          <img src={ item.image}alt=''className='w-50'/>
        </div>
        </> || '---', 

    name_en: item.name_en || '---',
    name_ar: item.name_ar || '---',
    actions: (
      <div className='d-flex align-items-center'>
        <div 
          className='d-flex align-items-center' 
          style={{ cursor: "pointer" }} 
          onClick={() => navigate(`/dashboard/edit-category/${item?.id}`)}
        >
          <BorderColorIcon
            sx={{ 
              color: '#6C757D', 
              fontSize: '1rem', 
              marginLeft: '5px',
              marginRight: '5px' // أضف مسافة بسيطة من الجهة الأخرى أيضاً
            }}
          />
          <p className='mb-0' style={{ fontSize: '1rem', color: '#6C757D' }}>
            {currentLocal.home.edit}
          </p>
        </div>
      </div>
    )
  };
});
  return (
    <div className='outlit_bg px-4'>
      <AddHeader
        title={currentLocal.home.categories}
        text={currentLocal.home.addcategory}
        handleSubmit={() => navigate("/dashboard/add-category")}
      />
      <FilterContainer
        exportexcel={false}
        searchState={false}
      />
{categories.length>0&&
      <div className='mx-4'>
        <CustomTable
          headCells={header}
          rows={myData} />
      </div>
}
    </div>
  )
}

export default Categories
